import { render } from "./tableContext.vue?vue&type=template&id=609c67ee"
import script from "./tableContext.vue?vue&type=script&lang=js"
export * from "./tableContext.vue?vue&type=script&lang=js"

import exportComponent from "D:\\eclipse\\workSpaceIDEA\\BioTechLeague_HUIDU_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__